<template>
  <div>
    <div v-if="evaluationWeight === 4">
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId1"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="1"/>
          <label :for="rId1">
            <div class="escala1">1</div>&nbsp;Abaixo do esperado (0 a 50%): Não apresenta os resultados esperados.
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId2"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="2"/>
          <label :for="rId2">
            <div class="escala2">2</div>&nbsp;Em desenvolvimento (51 a 79%): Apresenta os resultados esperados esporadicamente.
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId3"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="3"/>
          <label :for="rId3">
            <div class="escala3">3</div>&nbsp;Dentro do esperado (80 a 100%): Apresenta os resultados esperados.
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId4"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="4"/>
          <label :for="rId4">
            <div class="escala4">4</div>&nbsp;Acima do esperado (101 a 120%):Supera os resultados esperados frequentemente.
          </label>
      </div>
    </div>
    <div v-if="evaluationWeight === 5">
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId1"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="1"/>
          <label :for="rId1">
            <div class="escala1">1</div>&nbsp;Apresenta minimamente a competência avaliada. <div class="vezes">(até 40% das vezes)</div>
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId2"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="2"/>
          <label :for="rId2">
            <div class="escala2">2</div>&nbsp;Apresenta poucas vezes a competência avaliada. <div class="vezes">(entre 40.1% e 60% das vezes)</div>
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId3"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="3"/>
          <label :for="rId3">
            <div class="escala3">3</div>&nbsp;Apresenta muitas vezes a competência avaliada. <div class="vezes">(entre 60.1% e 80% das vezes)</div>
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId4"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="4"/>
          <label :for="rId4">
            <div class="escala4">4</div>&nbsp;Apresenta na maioria das vezes a competência avaliada. <div class="vezes">(entre 80.1% e 95% das vezes)</div>
          </label>
      </div>
      <div class="n-radio radio" :class="radioClasses">
          <input :id="rId5"
                type="radio"
                :name="cbId"
                v-model="answer"
                :disabled="disabled"
                value="5"/>
          <label :for="rId5">
            <div class="escala5">5</div>&nbsp;Apresenta sempre a competência avaliada. <div class="vezes">(entre 95.1% e 100% das vezes)</div>
          </label>
      </div>
    </div>       
  </div> 
</template>
<script>
  export default {
    name: 'evaluation-answer',
    props: {
      evaluationWeight: [Number],
      answerEdit: [Number],
      skillId: [Number],
      label: [String, Number],
      disabled: [Boolean, String],
      inline: Boolean,
      type: {
        type: String,
        default: 'neutral'
      }
    },
    data () {
      return {
        answer: this.answerEdit,
        cbId: '',
        rId1: '',
        rId2: '',
        rId3: '',
        rId4: '',
        rId5: ''
      }
    },
    computed: {
      inlineClass () {
        if (this.inline) {
          return `radio-inline`
        }
        return ''
      },
      radioClasses () {
        return `radio-${this.type} ${this.inlineClass}`
      }
    },
    created () {
      this.cbId = Math.random().toString(16).slice(2)
      this.rId1 = Math.random().toString(16).slice(2)
      this.rId2 = Math.random().toString(16).slice(2)
      this.rId3 = Math.random().toString(16).slice(2)
      this.rId4 = Math.random().toString(16).slice(2)
      this.rId5 = Math.random().toString(16).slice(2)
    },
    watch: {
      answer (val) {
        let data = {
          skillId: this.skillId,
          answerValue: val
        }
        this.$emit('setEvaluationAnswer', data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/EvaluationAnswer.vue